import { FC, useState } from 'react';
import { Role } from '@/models/auth';
import {
  BottomNavigationAction,
  BottomNavigation as BottomNavigationMui,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { routes } from '@/features/navigation/constants';
import { Link } from 'react-router';

export const BottomBar: FC<{
  role: Role;
}> = ({ role }) => {
  const { t } = useTranslation();
  const [value, setValue] = useState(0);

  return (
    <div className="fixed bottom-0 left-0 right-0 border-gray-100 py-1 border bg-white">
      <BottomNavigationMui
        showLabels
        value={value}
        onChange={(_, newValue) => {
          setValue(newValue);
        }}
      >
        {routes[role].map(({ to, Icon, labelKey }) => (
          <BottomNavigationAction
            key={labelKey}
            component={Link}
            to={to}
            label={t(labelKey)}
            icon={<Icon style={{ fontSize: 30, marginRight: 5 }} />}
          />
        ))}
      </BottomNavigationMui>
    </div>
  );
};
